// 楼宇管理
const build = () => import( /* webpackChunkName: "basic" */ '@/pages/basic/views/venue/build/Build.vue')
// 场室管理
const type = () => import( /* webpackChunkName: "basic" */ '@/pages/basic/views/venue/type/Type.vue')

const basic = [
  // basic router
  {
    path: 'build',
    name: 'build',
    component: build,
  },
  {
    path: 'type',
    name: 'type',
    component: type,
  }
]
export default basic;
